import { memo } from "react";
import { Box, css } from "@storyofams/react-ui";

export const ShopifyRichText: React.FC<any> = memo(
  ({ content, styles = {}, ...props }) => {
    return (
      <Box
        lineHeight={[1.5, "auto"]}
        fontSize={2}
        maxWidth="100%"
        overflow="visible"
        css={css({
          img: {
            display: "none !important",
          },

          "h1, h2, h3, h4, h5, h6": {
            fontSize: 3,
            fontWeight: "bold",
            lineHeight: 1.5,
            fontFamily: "heading",
            mb: 2,
            mt: 2,

            "&:not(:first-child)": {
              mt: 2,
            },
          },

          p: {
            mt: "10px",
            "&:not(:last-child)": {
              mb: 2,
            },
          },

          li: {
            mb: 0.5,
            ml: 2.25,
          },
          ul: {
            mb: "7px",
          },
          a: {
            background: "url(/images/nav-underline.svg) bottom no-repeat ",
            backgroundSize: "100% 40%",
            backgroundPosition: "0 0.95em",
            display: "inline-block",
            transition: "background-position 0.42s ease-in-out",
            height: "1.6em",
            "&:hover": {
              backgroundPosition: "left calc(200px - 100%) top 0.95em",
            },
          },
          "*": {
            float: "unset !important",
          },
          ...styles,
        })}
        {...props}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }
);
